import { render, staticRenderFns } from "./DirectionTable.vue?vue&type=template&id=5a28e040&scoped=true&"
import script from "./DirectionTable.vue?vue&type=script&lang=js&"
export * from "./DirectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28e040",
  null
  
)

export default component.exports